
import { Component, OnInit } from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { TopnavComponent } from '../topnav/topnav.component';

@Component({
  selector: 'lns-app-layout',
  standalone: true,
  imports: [TopnavComponent, FooterComponent],
  templateUrl: './app-layout.component.html'
})
export class AppLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
